import React, { useEffect, useState } from "react";
import { ModalContainer } from "../partials/modalbackground";
import { Icon } from "@iconify/react";
import { InputWithIcon } from "../partials/inputs";
import PrimaryBtn from "../partials/btn";
import { Controller, useForm } from "react-hook-form";
import { apiCall, useApiCall } from "../../data/useFetcher";
import { useUsersStore } from "../../data/stores/loggerStore";
import { IoMdClose } from "react-icons/io";
import Extractor, { toCamel } from "../../data/useExtractor";
import ArrowDown from "../../assets/icons/arrow-down.svg";
// import useErrorStore from "../../data/stores/errorStore";
import toast from "react-hot-toast";

interface FormType {
  email: string;
  organizationName: string;
  country: string;
}

const InviteModal = ({ handleModal, handleClose }) => {
  const {
      control,
      handleSubmit,
      formState: { errors },
    } = useForm({
      defaultValues: {
        organizationName: "",
        email: "",
        country: "",
      },
    }),
    { onSubmitAPI, loading } = useApiCall(),
    { getDynamicLogger, regionCountry }: any = useUsersStore();

  useEffect(() => {
    apiCall({
      type: "get",
      url: `/api/v1/data-system/manage-region-country?pagination=not&useHardCoded=true`,
      getter: (d: any) => getDynamicLogger(d, "regionCountry"),
    });
  }, []);

  const onSubmit = async (data: FormType) => {
    try {
      await onSubmitAPI({
        url: `/api/v1/auth/user/manage-users/manage-invite`,
        type: "post",
        data: { members: [data] },
        toggleModal: () => {
          handleModal();
          // Show success message for email sending
          toast.success(`Invitation sent successfully to ${data.email}`);
          apiCall({
            type: "get",
            url: `/api/v1/auth/user/manage-users/manage-invite?privilege=system owner`,
            getter: (d: any) => getDynamicLogger(d, "allData"),
          });
        },
      });
    } catch (error: any) {
      console.error("Invite error:", error);
      toast.error("Failed to send invitation. Please try again.");
    }
  };

  return (
    <div>
      <ModalContainer>
        <div className="bg-white modal-shadow w-[400px] rounded-xl p-6">
          <div
            style={{
              border: "8px solid #E6F3FE",
            }}
            className="size-12 rounded-full flex justify-center items-center bg-[#E6F3FE]"
          >
            <Icon
              icon={"mingcute:user-add-line"}
              color="#2070B8"
              style={{
                fontSize: "24px",
              }}
            />
          </div>
          <h4 className="text-lg my-3 font-medium text-sec">
            Invite collaborators
          </h4>
          <p className="text-sm font-normal text-[#667085]">
            Invite focal person to complete this assessment.{" "}
          </p>
          <form onSubmit={handleSubmit(onSubmit)} className="mt-5">
            <div className="space-y-4">
              <div>
                <Controller
                  name="organizationName"
                  control={control}
                  rules={{
                    required: "This field is required",
                  }}
                  render={({ field: { value, onChange, name } }) => (
                    <InputWithIcon
                      icon="la:user"
                      placeholder="Lusaka water"
                      label="Organisation Name"
                      value={value}
                      onChange={onChange}
                      name={name}
                    />
                  )}
                />
                {errors.organizationName && (
                  <p className="text-[#dc2626] text-xs mt-4">
                    {errors.organizationName.message}
                  </p>
                )}
              </div>
              <div>
                <Controller
                  name="email"
                  control={control}
                  rules={{
                    required: "This field is required",
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: "Invalid email format",
                    },
                  }}
                  render={({ field: { value, onChange, name } }) => (
                    <InputWithIcon
                      icon="mdi-light:email"
                      placeholder="contact@lusaka.org"
                      label="Email address"
                      type="email"
                      value={value}
                      onChange={onChange}
                      name={name}
                    />
                  )}
                />
                {errors.email && (
                  <p className="text-[#dc2626] text-xs mt-3">
                    {errors.email.message}
                  </p>
                )}
              </div>
              <div>
                <Controller
                  name="country"
                  control={control}
                  rules={{
                    required: "This field is required",
                  }}
                  render={({ field: { value, onChange, name } }) => (
                    <InputWithIcon
                      icon="mdi:web"
                      placeholder="Country"
                      label="Country of Operation"
                      value={value}
                      onChange={onChange}
                      name={name}
                      type="select"
                      options={regionCountry?.docs
                        ?.find((it: any) => it?.category === "COUNTRY")
                        ?.data?.sort(
                          (
                            a: { title: { toString: () => string } },
                            b: { title: { toString: () => any } }
                          ) => {
                            // Compare the values of the specified key in a case-insensitive manner
                            return a?.title
                              ?.toString()
                              ?.localeCompare(b?.title?.toString());
                          }
                        )
                        ?.map((it: any) => {
                          return {
                            ...it,
                            _id: it?.title,
                          };
                        })}
                    />
                  )}
                />
                {errors.country && (
                  <p className="text-[#dc2626] text-xs mt-4">
                    {errors.country.message}
                  </p>
                )}
              </div>
            </div>
            <div className="mt-8  gap-4 items-center w-full grid grid-cols-2">
              <button
                onClick={handleClose}
                type="button"
                className="main-shadow main-border h-11 bg-transparent text-es-gray-200 text-base font-medium
                "
              >
                Cancel
              </button>
              <PrimaryBtn
                text="Send Invite"
                width="w-full"
                type="submit"
                loading={!!loading}
              />
            </div>
          </form>
        </div>
      </ModalContainer>
    </div>
  );
};

export default InviteModal;

type AddNew = {
  handleClose: () => void;
  handleImport?: (pres: any) => void;
  title?: string;
  subtitle?: string;
  sample?: any;
  processInner?: any;
  loading?: boolean;
};

export const AddUsersModal = ({
  handleClose,
  title,
  subtitle,
  handleImport,
  sample,
  processInner,
}: AddNew) => {
  const [pres, setPres] = useState<any>(null),
    { onSubmitAPI, loading } = useApiCall(),
    { getDynamicLogger } = useUsersStore(),
    handleSubmit = async () => {
      let itemForm: any[] = [];
      if (pres?.length === 0)
        return toast.error("Bulk Upload' details required");
      try {
        for (let p = 0; p < pres?.length; p++) {
          const element = pres?.[p];
          itemForm?.push(toCamel(element));
        }
      } catch (err) {
        if (err) console.log({ error: err.response?.data, err });
      }
      if (itemForm?.length === 0) return toast.error("Invitee required");
      for (let f = 0; f < itemForm.length; f++) {
        const { country, organizationName, email } = itemForm[f];

        if (!email || !organizationName || !country)
          return toast.error(`S/N ${f + 1} Invite details is required`);
      }

      try {
        await onSubmitAPI({
          url: `/api/v1/auth/user/manage-users/manage-invite`,
          type: "post",
          data: { members: itemForm },
          toggleModal: () => {
            handleImport(itemForm);
            // Show success message for bulk email sending
            toast.success(
              `Invitations sent successfully to ${itemForm.length} recipients`
            );
            apiCall({
              type: "get",
              url: `/api/v1/auth/user/manage-users/manage-invite?privilege=system owner`,
              getter: (d: any) => getDynamicLogger(d, "allData"),
            });
          },
        });
      } catch (error: any) {
        console.error("Bulk invite error:", error);
        toast.error("Failed to send bulk invitations. Please try again.");
      }
    };

  return (
    <div>
      <ModalContainer>
        <div className="bg-white modal-shadow w-[400px] rounded-xl p-6">
          <div className="flex justify-between">
            <div>
              <h3 className="text-xl font-bold text-black">
                {title || `Upload new users list`}
              </h3>
              <p className="text-sm mt-2 font-normal text-[#344054]">
                {subtitle || `Add new users`} from an excel or csv file.
                Download sample file
              </p>
            </div>
            <IoMdClose
              size={20}
              onClick={handleClose}
              className="cursor-pointer"
              color="#A6A6A6"
            />
          </div>
          <div className="mt-6">
            {/* <FileInput /> */}
            <Extractor
              pres={pres}
              setPres={setPres}
              processInner={processInner}
            />
          </div>
          <div className="mt-4 flex flex-col justify-between items-center">
            {sample ? (
              <>
                <a
                  href={sample}
                  download={sample?.name}
                  target="_blank"
                  rel="noreferrer"
                  className="flex gap-3 items-center"
                >
                  <img src={ArrowDown} alt="" className="" />
                  <h6 className="text-[#3787FF] font-medium text-base">
                    Download sample file
                  </h6>
                </a>
              </>
            ) : (
              <div className="flex gap-3 items-center">
                <img src={ArrowDown} alt="" className="" />
                <h6 className="text-[#3787FF] font-medium text-base">
                  Download sample file
                </h6>
              </div>
            )}
            <div className="mt-8  gap-4 items-center w-full grid grid-cols-2">
              <PrimaryBtn
                onClick={handleClose}
                className="border border-[#3787FF] w-full"
                text={"Cancel"}
                bg={"transparent"}
                color={"#3787FF"}
                disabled={!!loading}
              />
              <PrimaryBtn
                onClick={handleSubmit}
                text={"Import"}
                bg={"#3787FF"}
                color={"white"}
                className="w-full bg-[#3787FF] text-white"
                loading={!!loading}
              />
            </div>
          </div>
        </div>
      </ModalContainer>
    </div>
  );
};
